import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useNuStationData } from '../../hooks/useNuStationData';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import { CONSTANTS } from '../../utils/constants';
import classnames from 'classnames';
import { useNavigation } from '../../hooks/useNavigation';
import ContentNotFoundPage from './ContentNotFoundPage';

const componentClass = 'shopPage';

const ShopListPage = () => {
    const { isProcessing, content: { shop: shopProducts = [] } } = useAppState();
    const { loadPage } = useNavigation();

    const renderShopProducts = () => {
        return (shopProducts || []).map(c => {
            const {image, slug, title, field_7: price} = c;
            return <div className={`${componentClass}__item`} onClick={() => loadPage(`/shop/${slug}`)}>
                <img src={getUploadedImagePath(image)} alt={`${title} | NuStation Store`} />
                <div>
                    <p>{ title }</p>
                    <p>${ price }</p>
                </div>
            </div>
        });
    };

    return !isProcessing ? <article className={componentClass}>
        <div className={`${componentClass}__header`}>
            <h1>The NuStation Store</h1>
        </div>
        <div className={`${componentClass}__content`}>
            <div className={`${componentClass}__list`}>
                { renderShopProducts() }
            </div>
        </div>
    </article> : <ContentNotFoundPage isProcessing={isProcessing} /> ;
};

export default ShopListPage;
